<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <base-notice-item data-test="ir35-freelancer-alert" :button-text="buttonText" :button-url="buttonUrl" :status="status">
    <template #head>
      <strong>{{ $t('Your default answers for IR35') }}</strong>
    </template>
    <template #icon>
      <img
        src="/gfx/ir35-logo-indigo.svg"
        class="pull-right m-l-10"
        style="max-width: 40px; height: auto"
      />
    </template>
    <template #body>
      <p v-if="hasAnsweredOldQuestions">
        We’ve added new questions related to IR35 due to recent changes in UK employment laws.
        Please answer these new questions to keep your IR35 default answers up to date.
      </p>
      <p>
        Your default answers to our questions related to IR35 will be applied to Status
        Determination Statements (SDS) on new contracts in Worksome when applicable.
      </p>
      <p v-if="yjob !== null">
        This job may fall within the off-payroll working rules known as ‘IR35’.
        <br />
        If the hire is determined to be inside IR35, tax and national insurance will need to be paid
        prior to final payouts from bills.
        <br />
        <a
          href="https://help.worksome.dk/en/articles/3669299-worksome-s-ir35-guide-for-freelancers"
          target="_blank"
          class="f-500"
        >
          Get more help in our IR35 Guide
          <i class="zmdi zmdi-open-in-new"></i>
        </a>
      </p>
    </template>
  </base-notice-item>
</template>

<script>
/* eslint-disable import-x/extensions */
import gql from 'graphql-tag'
import RedirectUriMixin from '@/mixins/RedirectUriMixin'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export const fragments = {
  account: gql`
    fragment Ir35FreelancerAlertAccount on Account {
      localId
    }
  `,
}

export default {
  name: 'Ir35FreelancerAlert',
  mixins: [RedirectUriMixin],
  props: {
    freelancer: {
      type: Object,
      required: true,
    },
    hasAnsweredOldQuestions: {
      type: Boolean,
      required: true,
    },
    yjob: {
      type: Object,
      default() {
        return null
      },
    },
  },
  computed: {
    buttonText() {
      if (this.hasAnsweredOldQuestions) {
        return 'Update answers'
      }
      return 'Answer IR35 questions'
    },
    buttonUrl() {
      return laravelNamedRoute(
        namedRoutes.determinations.edit,
        {
          determination: 'ir35',
          context: 'freelancer',
          id: this.freelancer.localId,
          redirect_uri: this.redirectUri,
        },
        false,
      )
    },
    status() {
      if (this.hasAnsweredOldQuestions) {
        return 'You have new IR35 questions to answer'
      }
      return 'Information missing'
    },
  },
}
</script>
